import type { DocSection } from '../types'
import { FIG_BLACKLIST } from '../figures'

export const blacklistSection: DocSection = {
  id: 'blacklist',
  title: 'Liste noire',
  icon: 'x-circle',
  accent: '#EF4444',
  summary: "Empêcher qu'un numéro soit jamais rappelé : ajout, portée (tout le compte ou une campagne).",
  minRole: 'admin',
  articles: [
    {
      id: 'principe',
      title: 'À quoi sert la liste noire',
      summary: 'Un numéro blacklisté n\'est plus jamais composé.',
      icon: 'ban',
      blocks: [
        { type: 'p', text: "La **liste noire** garantit qu'un numéro **ne sera plus jamais appelé** : il est retiré des numéros à appeler de toutes (ou d'une) campagne(s) et **ignoré lors des imports**." },
        { type: 'callout', variant: 'tip', title: 'Bloqué même en composant à la main', text: "Même si vous **tapez vous-même** un numéro blacklisté dans le softphone, l'appel est **refusé** : PexiTalk vérifie la liste noire juste avant de composer (et reconnaît le numéro quel que soit son format). Impossible d'appeler par erreur un numéro interdit." },
        { type: 'callout', variant: 'info', title: 'Obligation fréquente', text: "Respecter une demande « ne plus me rappeler » est souvent une **obligation légale**. La liste noire est l'outil pour la garantir techniquement." },
      ],
    },
    {
      id: 'ajouter',
      title: 'Ajouter un numéro',
      summary: 'Pendant un appel (agent) ou via la page de gestion (admin).',
      icon: 'plus',
      blocks: [
        { type: 'h', text: 'Deux façons' },
        { type: 'list', items: [
          "**Pendant un appel** : l'agent dispose toujours d'une action **Liste noire** dans le softphone (le contact demande à ne plus être appelé).",
          "**Page Liste noire** (admin) : ajout manuel d'un ou plusieurs numéros, avec un **motif** optionnel.",
        ] },
        { type: 'figure', svg: FIG_BLACKLIST, alt: 'Fenêtre de mise en liste noire', caption: "Mise en liste noire d'un numéro pendant un appel, avec motif optionnel." },
        { type: 'h', text: 'Comment les numéros sont comparés' },
        { type: 'p', text: "PexiTalk reconnaît le numéro **quelle que soit sa façon d'être écrit** (avec ou sans indicatif, avec ou sans espaces). Vous n'avez donc pas besoin de saisir toutes les variantes d'un même numéro." },
      ],
    },
    {
      id: 'portee',
      title: 'Portée : globale ou par campagne',
      summary: 'Bloquer partout, ou seulement dans une campagne.',
      icon: 'shield',
      blocks: [
        { type: 'table', headers: ['Portée', 'Effet'], rows: [
          ['**Globale** (compte)', "Le numéro est exclu de **toutes** les campagnes du compte. C'est le cas par défaut quand un agent blackliste en appel."],
          ['**Par campagne**', "Le numéro n'est bloqué que dans **cette** campagne, pas les autres."],
        ] },
        { type: 'callout', variant: 'info', text: "Les deux coexistent : un même numéro peut être en liste noire **globale** ET listé spécifiquement dans une campagne." },
        { type: 'callout', variant: 'tip', title: 'Propagation', text: "Mettre un numéro en liste noire **ferme aussi** les fiches en attente correspondantes, et l'import les **bloque** : la protection s'applique immédiatement et durablement." },
      ],
    },
  ],
}
